export default __webpack_public_path__ + "static/media/newCard.f862a8ea.png";